import { ID_TYPE, IAPP } from '@/const/types/index';
/* state */

export interface CurrentCampaignType {
    id: ID_TYPE;
    name: string;
    app: IAPP | null;
}
export interface CurrentAdsetType {
    idList: ID_TYPE[];
    name: string;
}

export interface CampaignState {
    currentCampaign: CurrentCampaignType;
    currentAdset: CurrentAdsetType;
}

/* ActionError */
export enum ActionError {
    SET_CURRENT_CAMPAIGN = 1,
    CLEAR_CURRENT_CAMPAIGN,
    SET_CURRENT_ADSET,
    CLEAR_CURRENT_ADSET,
}
